module.exports = __webpack_public_path__ + "img/pa_directory_inactive.3d40b7e5.svg";